module.exports = __webpack_public_path__ + "img/search-logo.29bb7e86.png";